import { getTypedTranslation } from "syf-js-utilities";
import englishTranslations from "./lang/en";
import spanishTranslations from "./lang/es";
var getTranslation = function () {
    return getTypedTranslation({ en: englishTranslations, es: spanishTranslations });
};
export default getTranslation;
